import { Container, Row, Col, Card } from 'react-bootstrap';
import logo from "../../../images/logo-nero-sportid.svg";

// Pagina pubblica di esito raggiunta dai link nelle email (verifica indirizzo,
// cancellazione account). La vedono soprattutto gli utenti dell'app, quindi
// niente menu né login del manager: solo il messaggio.
const PaginaEsito = ({ titolo, variante = 'success', children }) => {
    const colore = variante === 'danger' ? '#dc3545' : '#E2801E';

    return (
        <div className="min-vh-100 d-flex align-items-center py-4" style={{ backgroundColor: '#f8f9fa' }}>
            <Container>
                <Row className="justify-content-center">
                    <Col md={8} lg={6}>
                        <Card className="shadow-sm border-0">
                            <Card.Body className="p-4 p-md-5 text-center">
                                <img src={logo} alt="SportId" style={{ height: '60px' }} className="mb-4" />
                                <h3 className="mb-3" style={{ color: colore }}>{titolo}</h3>
                                <div className="text-dark">{children}</div>
                                <div className="mt-4">
                                    <small className="text-muted">
                                        Hai bisogno di aiuto? Scrivi a <a href="mailto:hello@sportid.it">hello@sportid.it</a>
                                    </small>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default PaginaEsito;
